import React from 'react';
import { Phone, Mail, MapPin, Facebook, Clock, ArrowRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-900 text-gray-300 pt-24 pb-12 border-t border-white/10" data-id="element-150">
      <div className="max-w-7xl mx-auto px-4" data-id="element-151">
        {/* Top Row CTA */}
        <div className="bg-navy-800 rounded-2xl p-8 md:p-12 mb-16 border border-white/5 flex flex-col lg:flex-row items-center justify-between gap-8" data-id="element-152">
          <div className="max-w-xl" data-id="element-153">
            <h3 className="text-2xl font-heading font-extrabold text-white mb-2" data-id="element-154">
              Need an Electrician Now?
            </h3>
            <p className="text-gray-300" data-id="element-155">
              We're ready to help with any electrical issue, big or small.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto" data-id="element-156">
            <a href="tel:0418381988" className="bg-orange hover:bg-orange-600 text-white px-8 py-4 rounded-xl font-extrabold text-lg flex items-center justify-center gap-2 transition-colors" data-id="element-157">
              <Phone className="w-5 h-5" data-id="element-158" />
              0418 381 988
            </a>
            <a href="#quote" className="bg-white/10 hover:bg-white/20 text-white border border-white/10 px-8 py-4 rounded-xl font-extrabold text-lg flex items-center justify-center gap-2 transition-colors" data-id="element-159">
              Book Online
              <ArrowRight className="w-5 h-5" data-id="element-160" />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16" data-id="element-161">
          {/* Brand Col */}
          <div className="space-y-8 lg:col-span-2" data-id="element-162">
            <img src="https://cdn.magicpatterns.com/uploads/keXDJJ6XdrR4HdR9pRaeSp/pasted-image.png" alt="Completely Electrical" className="h-14" data-id="element-163" />
            <p className="text-base leading-relaxed text-gray-300 max-w-md" data-id="element-164">
              Perth's south side electrical experts. Delivering premium, quality
              electrical services for residential and commercial clients who
              value workmanship over the cheapest price.
            </p>
            <div className="flex gap-4" data-id="element-165">
              <a href="#" className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center hover:bg-orange hover:text-white transition-colors border border-white/10 hover:border-orange" data-id="element-166">
                <Facebook className="w-5 h-5" data-id="element-167" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-168">
            <h4 className="text-white font-heading font-extrabold text-xl mb-6" data-id="element-169">
              Quick Links
            </h4>
            <ul className="space-y-4 text-base font-medium" data-id="element-170">
              <li data-id="element-171">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-172">
                  Home
                </a>
              </li>
              <li data-id="element-173">
                <a href="#about" className="hover:text-orange transition-colors" data-id="element-174">
                  About Us
                </a>
              </li>
              <li data-id="element-175">
                <a href="#residential" className="hover:text-orange transition-colors" data-id="element-176">
                  Residential Services
                </a>
              </li>
              <li data-id="element-177">
                <a href="#commercial" className="hover:text-orange transition-colors" data-id="element-178">
                  Commercial Services
                </a>
              </li>
              <li data-id="element-179">
                <a href="#emergency" className="text-red-400 hover:text-red-300 transition-colors font-bold" data-id="element-180">
                  24/7 Emergency
                </a>
              </li>
              <li data-id="element-181">
                <a href="#contact" className="hover:text-orange transition-colors" data-id="element-182">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-183">
            <h4 className="text-white font-heading font-extrabold text-xl mb-6" data-id="element-184">
              Core Services
            </h4>
            <ul className="space-y-4 text-base font-medium" data-id="element-185">
              <li data-id="element-186">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-187">
                  Split System AC
                </a>
              </li>
              <li data-id="element-188">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-189">
                  Lighting Upgrades
                </a>
              </li>
              <li data-id="element-190">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-191">
                  New Build Lighting
                </a>
              </li>
              <li data-id="element-192">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-193">
                  Fault Finding
                </a>
              </li>
              <li data-id="element-194">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-195">
                  Switchboard Upgrades
                </a>
              </li>
              <li data-id="element-196">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-197">
                  Commercial Electrical
                </a>
              </li>
              <li data-id="element-198">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-199">
                  Renovations
                </a>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-200">
            <h4 className="text-white font-heading font-extrabold text-xl mb-6" data-id="element-201">
              Service Areas
            </h4>
            <ul className="space-y-4 text-base font-medium" data-id="element-202">
              <li data-id="element-203">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-204">
                  Huntingdale
                </a>
              </li>
              <li data-id="element-205">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-206">
                  Gosnells
                </a>
              </li>
              <li data-id="element-207">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-208">
                  Thornlie
                </a>
              </li>
              <li data-id="element-209">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-210">
                  Southern River
                </a>
              </li>
              <li data-id="element-211">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-212">
                  Harrisdale
                </a>
              </li>
              <li data-id="element-213">
                <a href="#" className="hover:text-orange transition-colors" data-id="element-214">
                  Maddington
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Contact Details Row */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 py-10 border-t border-white/10 mb-10" data-id="element-215">
          <div className="flex items-start gap-4" data-id="element-216">
            <div className="w-12 h-12 rounded-full bg-orange/10 flex items-center justify-center flex-shrink-0" data-id="element-217">
              <Phone className="w-6 h-6 text-orange" data-id="element-218" />
            </div>
            <div data-id="element-219">
              <span className="block text-sm text-gray-300 font-bold uppercase tracking-wider mb-1" data-id="element-220">
                Call Us
              </span>
              <a href="tel:0418381988" className="text-white font-extrabold hover:text-orange transition-colors text-xl" data-id="element-221">
                0418 381 988
              </a>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-222">
            <div className="w-12 h-12 rounded-full bg-orange/10 flex items-center justify-center flex-shrink-0" data-id="element-223">
              <Mail className="w-6 h-6 text-orange" data-id="element-224" />
            </div>
            <div data-id="element-225">
              <span className="block text-sm text-gray-300 font-bold uppercase tracking-wider mb-1" data-id="element-226">
                Email Us
              </span>
              <a href="mailto:brodie@completelyelectrical.net" className="text-white font-medium hover:text-orange transition-colors text-base" data-id="element-227">
                brodie@completelyelectrical.net
              </a>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-228">
            <div className="w-12 h-12 rounded-full bg-orange/10 flex items-center justify-center flex-shrink-0" data-id="element-229">
              <MapPin className="w-6 h-6 text-orange" data-id="element-230" />
            </div>
            <div data-id="element-231">
              <span className="block text-sm text-gray-300 font-bold uppercase tracking-wider mb-1" data-id="element-232">
                Location
              </span>
              <span className="text-white font-medium text-base" data-id="element-233">
                Huntingdale Rd,
                <br data-id="element-234" />
                Huntingdale WA 6110
              </span>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-235">
            <div className="w-12 h-12 rounded-full bg-orange/10 flex items-center justify-center flex-shrink-0" data-id="element-236">
              <Clock className="w-6 h-6 text-orange" data-id="element-237" />
            </div>
            <div data-id="element-238">
              <span className="block text-sm text-gray-300 font-bold uppercase tracking-wider mb-1" data-id="element-239">
                Hours
              </span>
              <span className="text-white font-medium text-base block" data-id="element-240">
                Open 24 Hours
              </span>
              <span className="text-red-400 font-bold text-base block mt-0.5" data-id="element-241">
                Emergency: 24/7
              </span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-sm font-medium text-gray-300" data-id="element-242">
          <p data-id="element-243">
            &copy; {new Date().getFullYear()} Completely Electrical. All rights
            reserved.
          </p>
          <div className="flex flex-wrap items-center gap-4 justify-center" data-id="element-244">
            <span className="bg-white/5 px-3 py-1 rounded-md border border-white/10" data-id="element-245">
              Fully Licensed & Insured
            </span>
          </div>
          <div className="flex gap-6" data-id="element-246">
            <a href="#" className="hover:text-white transition-colors" data-id="element-247">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-248">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}